import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';

// Minimal localStorage persister; can be swapped for IndexedDB later
function createLocalStoragePersister({ key = 'rq-cache' } = {}) {
  return {
    persistClient: async (client) => {
      try {
        const str = JSON.stringify(client);
        window.localStorage.setItem(key, str);
      } catch {}
    },
    restoreClient: async () => {
      try {
        const str = window.localStorage.getItem(key);
        if (!str) return undefined;
        return JSON.parse(str);
      } catch {
        return undefined;
      }
    },
    removeClient: async () => {
      try { window.localStorage.removeItem(key); } catch {}
    },
  };
}

export function QueryPersistenceProvider({ client, children }) {
  const persister = createLocalStoragePersister();
  return (
    <PersistQueryClientProvider client={client} persistOptions={{ persister }}>
      {children}
    </PersistQueryClientProvider>
  );
}
